const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? ''
const TOKEN_KEY = 'tg_game_dice_jwt'
let memoryToken: string | null | undefined

export function takeTokenFromUrl(): string | null {
  try {
    const u = new URL(window.location.href)
    const fromQuery = u.searchParams.get('token')
    if (fromQuery) {
      memoryToken = fromQuery
      try {
        sessionStorage.setItem(TOKEN_KEY, fromQuery)
      } catch {
        /* ignore */
      }
      u.searchParams.delete('token')
      const qs = u.searchParams.toString()
      window.history.replaceState(null, '', u.pathname + (qs ? `?${qs}` : '') + u.hash)
      return fromQuery
    }
  } catch {
    /* ignore */
  }
  if (memoryToken) return memoryToken
  try {
    const s = sessionStorage.getItem(TOKEN_KEY)
    if (s) {
      memoryToken = s
      return s
    }
  } catch {
    /* ignore */
  }
  return null
}

export async function getInitData(): Promise<string> {
  try {
    const legacy = (window as unknown as { Telegram?: { WebApp?: { initData?: string; ready?: () => void } } })
      .Telegram?.WebApp
    legacy?.ready?.()
    if (legacy?.initData) return legacy.initData
  } catch {
    /* ignore */
  }
  return ''
}

async function request<T>(path: string, options: RequestInit & { token?: string } = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (options.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  if (options.token) headers.set('Authorization', `Bearer ${options.token}`)
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers })
  if (!res.ok) {
    let msg = res.statusText
    try {
      const b = (await res.json()) as { error?: string }
      if (b.error) msg = b.error
    } catch {
      /* ignore */
    }
    throw new Error(msg)
  }
  return (await res.json()) as T
}

export function loginWithInitData(initData: string) {
  return request<{ token: string; user: { balance: number } }>('/api/auth/telegram', {
    method: 'POST',
    body: JSON.stringify({ init_data: initData }),
  })
}

export function loginDev() {
  return request<{ token: string; user: { balance: number } }>('/api/auth/dev', {
    method: 'POST',
    body: JSON.stringify({ username: 'local_dev', first_name: 'Local' }),
  })
}

export function fetchBalance(token: string) {
  return request<{ balance: number }>('/api/wallet/balance', { token })
}

export function quote(token: string, target: number, choice: string) {
  return request<{ odds: number }>(
    `/api/games/dice/quote?target=${target}&choice=${choice}`,
    { token },
  )
}

export type DiceRound = {
  id: string
  target: number
  choice: string
  roll: number
  odds: number
  bet_amount: number
  payout: number
  won: boolean
}

export function play(token: string, bet: number, target: number, choice: string) {
  return request<{ round: DiceRound }>('/api/games/dice/play', {
    method: 'POST',
    token,
    body: JSON.stringify({ bet_amount: bet, target, choice }),
  })
}
